import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

/** Normalize boolean claims from JWT payload (used on login, tenant switch, and initial load). */
export function userFromDecodedJwt(decoded) {
    if (!decoded) return null;
    let resellerId = null;
    if (decoded.resellerId != null && decoded.resellerId !== '') {
        const n = Number(decoded.resellerId);
        if (!Number.isNaN(n)) {
            resellerId = n;
        }
    }
    const showSettings =
        decoded.showSettings === undefined || decoded.showSettings === null
            ? true
            : decoded.showSettings === true || decoded.showSettings === 'true';
    let agencyId = null;
    if (decoded.agencyId != null && decoded.agencyId !== '') {
        const n = Number(decoded.agencyId);
        if (!Number.isNaN(n)) {
            agencyId = n;
        }
    }
    return {
        ...decoded,
        owner: decoded.owner === true || decoded.owner === 'true',
        chat_log_access_only:
            decoded.chat_log_access_only === true || decoded.chat_log_access_only === 'true',
        resellerId,
        showSettings,
        agencyId
    };
}

/** User belongs to an agency (JWT agency_id claim). */
export function isAgencyUser(user) {
    if (!user || user.agencyId == null || user.agencyId === '') return false;
    const n = Number(user.agencyId);
    return !Number.isNaN(n) && n > 0;
}

/**
 * Top-right Account Settings: agency users always; otherwise owner + tenant + showSettings JWT.
 */
export function shouldShowAccountSettings(user) {
    if (!user) return false;
    if (isAgencyUser(user)) return true;
    if (!user.owner) return false;
    const tid = user.tenantId;
    if (tid == null || tid === 0) return false;
    return user.showSettings === true;
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Try to get JWT from cookies first, then localStorage
        let token = null;
        if (typeof window !== 'undefined') {
            // Try cookies first
            const match = document.cookie.match(/jwtToken=([^;]+)/);
            if (match) {
                token = match[1];
            } else {
                token = localStorage.getItem('jwtToken');
            }
        }
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser(userFromDecodedJwt(decoded));
            } catch (e) {
                setUser(null);
            }
        } else {
            setUser(null);
        }
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
